import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import NotifyBellWhite from "images/notify_bell_white.svg";
import RadioInputPair from "components/design-system/radio-input-pair";
import RTRButton from "components/design-system/rtr-button";
import { openNotifyMeModal } from "slices/notifyMe-slice";
import MembershipShippingAddress from "components/source/membership/membership-shipping-address";
import MembershipPickWayfind from "components/source/membership/membership-pick-wayfind";
import { membershipStatePropType, userDataPropType, productPropType } from "components/propTypes";

const NotifyMePDPContent = ({
  membershipState,
  product,
  handleWayfindCtaClick,
  rentalPrice,
  purchasePrice,
  selectedSize,
  userData,
}) => {
  const dispatch = useDispatch();

  const handleNotifyMeOpen = e => {
    e.preventDefault();
    dispatch(openNotifyMeModal(selectedSize));
  };

  const baseContainerStyle = "flex flex-col";
  const contentContainerClass = `${baseContainerStyle} gap-6 mt-0.5 lg:gap-7`;
  const radioPickerClass = `${baseContainerStyle} gap-2.5`;
  return (
    <div className={contentContainerClass}>
      <div className={radioPickerClass}>
        <RadioInputPair
          id="renting"
          value="renting"
          disabled={true}
          checked={false}
          label={rentalPrice}
          onChange={() => {}}
        />
        <RadioInputPair
          id="purchasing"
          value="purchasing"
          disabled={true}
          checked={false}
          label={purchasePrice}
          onChange={() => {}}
        />
      </div>
      <RTRButton onClick={handleNotifyMeOpen} fullWidth={true}>
        <NotifyBellWhite /> notify me
      </RTRButton>
      <div className="flex flex-col gap-4">
        <MembershipShippingAddress />
        <MembershipPickWayfind
          handleWayfindCtaClick={handleWayfindCtaClick}
          membershipState={membershipState}
          product={product}
          userData={userData}
        />
      </div>
    </div>
  );
};

NotifyMePDPContent.propTypes = {
  handleWayfindCtaClick: PropTypes.func,
  membershipState: membershipStatePropType,
  product: productPropType,
  purchasePrice: PropTypes.string,
  rentalPrice: PropTypes.string,
  selectedSize: PropTypes.string,
  userData: userDataPropType,
};

export default NotifyMePDPContent;
